module.exports = AMap;


//////////////////
// WEBPACK FOOTER
// external "AMap"
// module id = 942
// module chunks = 